import {useNavigate} from 'react-router-dom';
import {useCallback} from 'react';

// Web-compatible navigation hook that mimics react-navigation API
export function useAppNavigation() {
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const navigateTo = useCallback(
    (screen: string, params?: Record<string, any>) => {
      const routes: Record<string, string> = {
        Frame: '/',
        Settings: '/settings',
        GallerySettings: '/settings/gallery',
        CalendarSettings: '/settings/calendar',
        AccountSettings: '/settings/account',
        Displays: '/settings/displays',
        Donation: '/settings/donate',
        Home: '/',
      };

      // Handle routes with dynamic params
      if (screen === 'Frame' && params?.displayId) {
        navigate(`/frame?displayId=${params.displayId}`, {state: params});
        return;
      }
      if (screen === 'DisplayEdit' && params?.displayId) {
        navigate(`/settings/displays/${params.displayId}`, {state: params});
        return;
      }
      if (screen === 'DisplayPhotos' && params?.displayId) {
        navigate(`/settings/displays/${params.displayId}/photos`, {state: params});
        return;
      }
      if (screen === 'DisplayCalendars' && params?.displayId) {
        navigate(`/settings/displays/${params.displayId}/calendars`, {state: params});
        return;
      }

      const path = routes[screen] || '/';
      navigate(path, {state: params});
    },
    [navigate],
  );

  return {
    navigate: navigateTo,
    goBack,
  };
}
